/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import * as color from '@constant/color';
import * as size from '@constant/size';
import React from 'react';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import TextBlock from 'component/common/block/text-block';

interface IProps {
  text: string;
  checked: boolean;
  design: {
    fontSize: 'tiny' | 'small' | 'medium' | 'large' | 'big' | 'huge';
    fontColor?: string;
    checkSize: 'small' | 'medium' | 'large';
    gap: string; // e.g: 10px
    checkedColor?: string;
    uncheckedColor?: string;
    backgroundColor?: string;
    width?: string; // e.g: 10px
    height?: string; // e.g: 10px
    bold?: boolean;
    border?: boolean;
  };
  onChange: any;
}

const Wrapper = styled.div<Pick<IProps, 'design'>>`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  width: ${(props) => props.design.width};
  height: ${(props) => props.design.height};
  box-sizing: border-box;
  border: ${(props) => (props.design.border ? `1.5px solid ${color.BLACK_2}` : 'none')};
  border-radius: ${size.BORDER_RADIUS_1};
  background-color: ${(props) => props.design.backgroundColor || 'transparent'};
  cursor: pointer;
`;

const CheckBoxInput: React.FC<IProps> = ({ text, checked, design, onChange }) => {
  let Icon;

  if (checked) {
    Icon = (
      <CheckBoxIcon
        onClick={onChange}
        fontSize={design.checkSize}
        sx={{ color: design.checkedColor || color.BLACK_1 }}
      />
    );
  } else {
    Icon = (
      <CheckBoxOutlineBlankIcon
        onClick={onChange}
        fontSize={design.checkSize}
        sx={{ color: design.uncheckedColor || color.BLACK_1 }}
      />
    );
  }
  // 체크박스에 클릭이벤트 넣기
  return (
    <>
      <Wrapper design={design}>
        {Icon}
        <div
          css={css`
            width: ${design.gap};
          `}
        />
        <TextBlock text={text} design={{ text: { size: design.fontSize, color: design.fontColor } }} />
      </Wrapper>
    </>
  );
};

export default CheckBoxInput;
